import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    ElementRef,
    HostBinding,
    inject,
    input,
    model,
    output,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { TrgDragDirective } from '../../utils/TrgDrag.directive';

@Component({
  selector: 'visual-editor-box',
  templateUrl: './VisualEditorBox.component.html',
  styleUrl: './VisualEditorBox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VisualEditorBoxComponent {
  readonly hostElement = inject(ElementRef<HTMLElement>);

  readonly Appearance = VisualEditorBox.Appearance;
  readonly appearance = input<VisualEditorBox.Appearance>(VisualEditorBox.Appearance.Fields);

  readonly canCollapse = input(false, { transform: booleanAttribute });
  readonly collapsed = model<boolean>(false);

  readonly canClose = input(false, { transform: booleanAttribute });
  readonly close = output<void>();

  readonly hideTitle = input(false);

  readonly dragDirective = input<TrgDragDirective>(null);
  readonly dragHandleTitle = input(false);

  readonly collapsedContent = viewChild('collapsedContentRef', { read: ElementRef });
  readonly hasCollapsedContent = computed(() => !!this.collapsedContent()?.nativeElement?.children.length);

  private readonly __updateClassName = effect(() => {
    let canCollapse = this.canCollapse();
    let collapsed = this.collapsed();
    let hasCollapsedContent = this.hasCollapsedContent();

    let el = <HTMLElement>this.hostElement.nativeElement;
    if (el) {
      el.classList.toggle('visual-editor-box', true);
      el.classList.toggle('visual-editor-box__canCollapse', canCollapse);
      el.classList.toggle('visual-editor-box__collapsed', collapsed);
      el.classList.toggle('visual-editor-box__collapsedWithContent', hasCollapsedContent);
    }
  });

  collapseClick(e: Event) {
    e.stopPropagation();
    let collapsed = !this.collapsed();
    this.collapsed.set(collapsed);
  }

  closeClick(e: Event) {
    e.stopPropagation();
    this.close.emit();
  }
}

export namespace VisualEditorBox {
  export enum Appearance {
    Fields = 'fields',
    Filter = 'filter'
  }
}
